// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QzZO","location":"Header_location__12UJI"};